(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function initFaqSearch(root) {
    var input = root.querySelector('[data-cs-faq-search]');
    var clearBtn = root.querySelector('[data-cs-faq-search-clear]');
    var emptyMsg = root.querySelector('[data-cs-faq-empty]');
    var items = root.querySelectorAll('[data-cs-faq-item]');
    if (!input || items.length === 0) return;

    function applyFilter() {
      var query = (input.value || '').trim().toLowerCase();
      var visibleCount = 0;

      items.forEach(function (item) {
        if (!query) {
          item.hidden = false;
          visibleCount++;
          return;
        }
        var haystack = item.getAttribute('data-cs-faq-text') || '';
        var match = haystack.indexOf(query) !== -1;
        item.hidden = !match;
        if (match) visibleCount++;
      });

      if (clearBtn) clearBtn.hidden = !query;
      if (emptyMsg) emptyMsg.hidden = visibleCount > 0;
    }

    input.addEventListener('input', debounce(applyFilter, 80));

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        applyFilter();
        input.focus();
      });
    }
  }

  function initChatTriggers() {
    var triggers = document.querySelectorAll('[data-cs-chat]');
    if (triggers.length === 0) return;

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
          window.tidioChatApi.open();
          return;
        }
        if (window.tidioChatApi && typeof window.tidioChatApi.show === 'function') {
          window.tidioChatApi.show();
          return;
        }
        var fallback = btn.getAttribute('data-cs-chat-fallback') || 'mailto:info@verfsale.com';
        window.location.href = fallback;
      });
    });
  }

  function setupSidebarResponsive() {
    var sidebars = document.querySelectorAll('[data-cs-sidebar] .cs-sidebar__details');
    if (sidebars.length === 0) return;
    var mq = window.matchMedia('(min-width: 991px)');

    function apply(matches) {
      sidebars.forEach(function (d) {
        if (matches) d.setAttribute('open', '');
        // On mobile we leave the attribute alone so the user's toggle state is preserved.
      });
    }
    apply(mq.matches);

    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { apply(e.matches); });
    } else if (mq.addListener) {
      mq.addListener(function (e) { apply(e.matches); });
    }
  }

  function init() {
    document.querySelectorAll('[data-cs-faq]').forEach(initFaqSearch);
    initChatTriggers();
    setupSidebarResponsive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var faq = e.target.querySelector ? e.target.querySelector('[data-cs-faq]') : null;
    if (faq) initFaqSearch(faq);
    initChatTriggers();
  });
})();
